import * as React from 'react';
import { render } from 'react-dom';
import {
  CartApp,
  CheckoutApp,
  FailureApp,
  LangSwitcherApp,
  MembershipAccountApp,
  MembershipForgotApp,
  MembershipFormsApp,
  MembershipNavApp,
  MinicartApp,
  ReceiptApp } from './apps';
import { ICheckoutContextConfig } from './config/contextCheckoutConfig.d';
import createdStore from './store/store';
import { createRestInstance } from './utils/apiUtils';
import { getConfig, getDataAttributeValue } from './utils/utils';
// import { fetchSelection } from './reducers/checkout';

const URL = (window as Window).multistepCheckoutApiUrl || process.env.API_URL;
const PORT = (window as Window).multistepCheckoutApiPort || process.env.API_PORT;
const apiUrl = PORT ? `${URL}:${PORT}` : `${URL}`;

// Create axios rest instance
document.addEventListener('DOMContentLoaded', createRestInstance(apiUrl));

window.initCheckoutComponents = () => {
  // Root react elements
  const checkoutEl = document.getElementById('CheckoutMultiStep');
  const minicartEl =
    (document.getElementById('CheckoutMultiStepMinicart') && [document.getElementById('CheckoutMultiStepMinicart')])
    || document.querySelectorAll('[data-js="multistep-minicart"]');
  const cartEl = document.getElementById('CheckoutMultiStepCart');
  const failureEl = document.getElementById('CheckoutMultiStepFailure');
  const receiptEl = document.getElementById('CheckoutMultiStepReceipt');
  const langSwitcherEl = document.getElementById('CheckoutMultiStepLangSwitcher');
  const membershipFormsEl = document.getElementById('CheckoutMultiStepMembershipFormsApp');
  const membershipNavEl =
    (document.getElementById('CheckoutMultiStepMembershipNavApp') && [document.getElementById('CheckoutMultiStepMembershipNavApp')])
    || document.querySelectorAll('[data-js="membership-login-nav-app"]');
  const membershipAccountEl = document.getElementById('CheckoutMultiStepMembershipAccountApp');
  const membershipForgotEl = document.getElementById('CheckoutMultiStepMembershipForgotApp');

  if (checkoutEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <CheckoutApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(checkoutEl)}
      />,
      checkoutEl);
  }

  if (minicartEl !== null) {
    [].map.call(minicartEl, (el: HTMLElement) => {
      render(
        // tslint:disable-next-line:jsx-wrap-multiline
        <MinicartApp
          store={createdStore.store}
          persistor={createdStore.persistor}
          cartLabel={getDataAttributeValue(el, 'label')}
        />, el);
    });
  }

  if (cartEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <CartApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(cartEl)}
      />, cartEl);
  }

  if (receiptEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <ReceiptApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(receiptEl)}
      />, receiptEl);
  }

  if (failureEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <FailureApp
        store={createdStore.store}
        persistor={createdStore.persistor}
      />, failureEl);
  }

  if (membershipNavEl !== null) {
    [].map.call(membershipNavEl, (el: HTMLElement) => {
      render(
        // tslint:disable-next-line:jsx-wrap-multiline
        <MembershipNavApp
          store={createdStore.store}
          persistor={createdStore.persistor}
          checkoutConfig={getConfig<ICheckoutContextConfig>(el)}
        />, el);
    });
  }

  if (membershipFormsEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <MembershipFormsApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(membershipFormsEl)}
      />, membershipFormsEl
    );
  }

  if (membershipAccountEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <MembershipAccountApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(membershipAccountEl)}
      />, membershipAccountEl
    );
  }

  if (membershipForgotEl !== null) {
    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <MembershipForgotApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        checkoutConfig={getConfig<ICheckoutContextConfig>(membershipForgotEl)}
      />, membershipForgotEl
    );
  }

  if (langSwitcherEl !== null) {
    const languages = [
      {
        language: 'en',
        name: 'English',
        default: true,
      },
      {
        language: 'pl',
        name: 'Polish',
        default: false,
      },
      {
        language: 'sv',
        name: 'Swedish',
        default: false,
      },
      {
        language: 'no',
        name: 'Norwegian',
        default: false,
      },
      {
        language: 'de',
        name: 'German',
        default: false,
      },
      {
        language: 'fi',
        name: 'Finnish',
        default: false,
      },
      {
        language: 'fr',
        name: 'French',
        default: false,
      },
    ];

    render(
      // tslint:disable-next-line:jsx-wrap-multiline
      <LangSwitcherApp
        store={createdStore.store}
        persistor={createdStore.persistor}
        languages={languages}
      />, langSwitcherEl);
  }
};

window.initCheckoutComponents();
